import React from "react";
import facebook, { instagram, pintrest, tiktok } from "../../common/SocialMedia";
import styles from "../Footer.module.scss";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

function FooterSocialMedia() {
  const isDesktop = useMediaQuery("(min-width: 1025px)");
  return (
    <div className={styles.follow_us}>
      <div className="row">
        <div className={`grid-xs-7 grid-sm-5 grid-md-6 ${styles.align_left}`}>
          <span className={`normal-md x-small-sm small-xs bold ${styles.follow_us_txt}`}>Follow &amp; tag us</span>
        </div>
        <div className={`grid-xs-5 grid-sm-7 grid-md-6 ${styles.icon_wrapper}`}>
          <div className={styles.space}>{facebook}</div>
          <div className={styles.space}> {instagram}</div>
          <div className={styles.space}> {pintrest}</div>
          <div className={styles.space}> {tiktok}</div>
        </div>
      </div>
    </div>
  );
}

export default FooterSocialMedia;
